module.exports = __webpack_public_path__ + "static/media/elsevier_logo.06393255.png";